import React, { PureComponent, Fragment } from 'react';

// import ReactEcharts from "echarts-for-react";
import ReactEcharts from "echarts-for-react";


var colors = ['#5793f3', '#d14a61', '#675bba'];


export default class BiaxialLineChart extends PureComponent {

  constructor(props) {
    super(props);

    var chartData = this.props.data;
    console.log(chartData);
    this.state = {
        monthList : ["1월", "2월", "3월", "4월", "5월", "6월", "7월", "8월", "9월", "10월", "11월", "12월"],
        max_val : chartData.max_val,
        use_time_max_val : chartData.use_time_max_val,
        loginList : chartData.login,
        useList : chartData.use,
        contentsList : chartData.contents,
        useTimeList : chartData.use_time
    }
  }

  componentWillReceiveProps = (nextProps) => {
      
      var chartData = nextProps.data ;

      this.setState({
        max_val : chartData.max_val,
        use_time_max_val : chartData.use_time_max_val,
        loginList : chartData.login,
        useList : chartData.use,
        contentsList : chartData.contents,
        useTimeList : chartData.use_time
      });
  }


  render() {

    const option = {
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'cross',
                crossStyle: {
                    color: '#999'
                }
            }
        },
        legend: {
            data: ['로그인', '유효활동', '콘텐츠', '사용시간']
        },
        xAxis: [
            {
                type: 'category',
                data: this.state.monthList,
                axisPointer: {
                    type: 'shadow'
                }
            }
        ],
        yAxis: [
            {
                type: 'value',
                name: '횟수',
                min: 0,
                max : this.state.max_val,
                interval: this.state.max_val / 5,
                position: 'left',
                axisLabel: {
                    formatter: (param) => { 
                        return param.toLocaleString();
                    }
                }
            },
            {
                type: 'value',
                name: '시간',
                min: 0,
                max: this.state.use_time_max_val,
                interval: this.state.use_time_max_val / 5,
                axisLabel: {
                    formatter: '{value} 분'
                }
            }
        ],
        series: [
            {
                name: '로그인',
                type: 'bar',
                data: this.state.loginList
            },
            {
                name: '유효활동',
                type: 'bar',
                data: this.state.useList
            },
            {
                name: '콘텐츠',
                type: 'bar',
                data: this.state.contentsList
            },
            {
                name: '사용시간',
                type: 'line',
                yAxisIndex: 1,
                data: this.state.useTimeList
            }
        ]
      };


    return (
      <ReactEcharts theme="macarons" option={option}  />
    );
  }
}
